<template>
	<div class="footer" ref="footView" >
		<div class="footer-content">
			<div class="footer-nav">
				<div class="nav-group" v-for="(item,index) in treeList" :key="item.columnId">
					<h3 style="font-size: large;">{{item.columnName}}</h3>
					<div style="color: #fff;margin-top: 3px;cursor: pointer;" v-for="(subItem,subIndex) in item.children" @click="gotozzRouter(subItem.linkHref)" :key="subItem.columnId">{{subItem.columnName}}</div>
					
				</div>
				
			</div>
			<div class="contact-info">
				<div class="service-hotline">
					<h3>全国案件服务热线</h3>
					<div class="phone">{{jianJieInfo.hotLinePhone}}</div>
				</div>
				<div class="address">
					<div class="addressCon">
						{{jianJieInfo.daoyouAddress}}
					</div>
				</div>
				<div style="clear:both;"></div>
				<div class="qr-codes">
					<div class="qr-item">
						<img :src="jianJieInfo.appQrCode" alt="扫码下载APP" />
						<span>扫码下载APP</span>
					</div>
					<div class="qr-item">
						<img :src="jianJieInfo.wxgzhQrCode" alt="关注微信公众号" />
						<span>关注微信公众号</span>
					</div>
					<div class="qr-item">
						<img :src="jianJieInfo.dyQrCode" alt="关注抖音号" />
						<span>关注抖音号</span>
					</div>
				</div>
			</div>
		</div>
		<div style="padding-bottom:60px;">
			<div class="footer-bottom">
				<div class="logo">
					<img src="../assets/images/logo.png" alt="道佑律师" />
				</div>
				<div class="copyright">Copyright © 北京道佑律师事务所 京ICP备19033368号-1</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
		columntTreelist,
		summaryList
	} from '@/api/webstation.js'
	export default {
		name: "Footer",
		data() {
			return {
				treeList:[],
				jianJieInfo:{}
			};
		},
		created(){
			this.getTreeList()
			this.getsummaryList()
		},
		methods: {
			gotozzRouter(link){
				this.$router.replace({
					path: link
				});
			},
			getTreeList(){
				let that = this
				columntTreelist({
					
				}).then(res => {
					if (res.code == 200) {
						that.treeList = res.data
						setTimeout(function() {
							let FooterV = that.$refs["footView"].offsetHeight;
							console.log('sssFooterV: ',FooterV);
							that.$emit("changFootHeight",FooterV)
						}, 200);
					}
				})
			},
			getsummaryList(){
				let that = this
				summaryList({
					"pageNum": "1",
					"pageSize": "1",
					"showModel": '1'
				}).then(res => {
					if (res.code == 200) {
						that.jianJieInfo = res.rows[0]
						 
					}
				})
			},
			goUrl(url) {
				window.open(url, "_blank");
			}
		}
	}
</script>
<style scoped>
	/* 底部样式 */
	.footer {
		width: 100%;
		background-color: #192F56;
		padding: 60px 0 0;
	}

	.footer-content {
		max-width: 85%;
		margin: 0 auto;
		padding: 0 40px;
		display: flex;
		justify-content: space-between;
	}

	.footer-nav {
		display: flex;
		gap: 80px;
	}

	.nav-group {
		display: flex;
		flex-direction: column;
		text-align:left;
	}

	.nav-group h3 {
		color: #fff;
		font-size: 16px;
		font-weight: normal;
		margin-bottom: 20px;
	}

	.nav-group a {
		color: rgba(255, 255, 255, 0.7);
		text-decoration: none;
		font-size: 14px;
		line-height: 28px;
		transition: color 0.3s;
	}

	.nav-group a:hover {
		color: #fff;
	}

	.contact-info {
		text-align: right;
		min-width: 400px;
	}

	.service-hotline h3 {
		color:#fff;
		font-size: 16px;
		font-weight: normal;
		margin-bottom: 5px;
		font-weight:bold;
	}

	.phone {
		color: #fff;
		font-size: 36px;
		font-weight: bold;
		margin-bottom: 20px;
		letter-spacing: 1px;
	}

	.address {
		color: rgba(255, 255, 255, 0.7);
		font-size: 14px;
		line-height: 1.6;
		margin-bottom: 20px;
		max-width: 300px;
		float:right;
	}
	.addressCon{
		text-align:left;
	}

	.qr-codes {
		display: flex;
		gap: 20px;
		justify-content: flex-end;
	}

	.qr-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 8px;
	}

	.qr-item img {
		width: 120px;
		height: 120px;
		background: #fff;
		border-radius: 4px;
	}

	.qr-item span {
		color: rgba(255, 255, 255, 0.7);
		font-size: 14px;
	}

	.footer-bottom {
		max-width:80%;
		margin:60px auto 0 auto;
		
		border-bottom: 1px solid #fff;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.footer-bottom .logo img {
		height: 40px;
		width: auto;
	}

	.copyright {
		color: #fff;
		font-size: 14px;
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.footer-content {
			flex-direction: column;
			gap: 40px;
		}

		.footer-nav {
			flex-wrap: wrap;
			gap: 40px;
		}

		.contact-info {
			text-align: left;
			min-width: auto;
		}

		.qr-codes {
			justify-content: flex-start;
		}

		.footer-bottom {
			flex-direction: column;
			gap: 20px;
			text-align: center;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue